<div class="notfound-wrapper">
  <div class="notfound-card">
    <div class="error-code">404</div>
    <h1 class="text-uppercase">Page Not Found</h1>
    <p class="notfound-text">
      The page you are looking for does not exist or has been moved.
    </p>
    <a routerLink="/dashboard" class="btn btn-success">
      <i class="fa fa-arrow-circle-left" aria-hidden="true"></i>
      Back to Dashboard
    </a>
    <p class="notfound-copy">
      Copyright &copy; {{ currentYear }}
      <a href="https://www.icashremit.com" target="_blank">ICASHREMIT</a>, All
      rights reserved.
    </p>
  </div>
</div>
